import React, { useState } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Divider from "@mui/material/Divider";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      //height: "5px",
      backgroundColor: "#91C73C",
      //borderRadius: "5px 5px 0px 0px",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabPanelRoot: {
    borderRadius: "5px",
    padding: "0.5rem 0.5rem",
  },
}));

export default function CustomTabs2(props) {
  const currentusertype = localStorage.getItem('userType');
  const classes = useStyles();
  const [value, setValue] = useState("0");

  const { data } = props;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value} className={classes.root}>
      <AppBar
        position="static"
        className={classes.demo3}
        style={{ boxShadow: "none", shadowColor: "red" }}
      >
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="styled tabs"
          scrollButtons="auto"
        >
          {data.map((arr) => (
            (!arr.admin || currentusertype == 1) ? <StyledTab key={arr.label} value={arr.value} label={arr.label} /> : <></>
          ))};
        </StyledTabs>
        <Typography className={classes.padding} />
      </AppBar>
      <Divider variant="fullWidth" />

      {data.map((arr) => (
        <TabPanel
          key={arr.label}
          value={arr.value}
          classes={{ root: classes.tabPanelRoot }}
        >
          {arr.component}
        </TabPanel>
      ))}
    </TabContext>
  );
}
